import React, { useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';

import './contact.css';

const Contact = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <section className="page-section">
            <Container>
                <div className="bg-img">
                    <h2 className="pageTitle">Contact Us</h2>
                </div>

                <Row className="contact__content__top">
                    <Col lg="3" md="3" sm="6">
                        <div className="cardContact">
                            <span>
                                <i className="ri-map-pin-line"> </i> Washington, DC
                            </span>
                        </div>
                    </Col>
                    <Col lg="3" md="3" sm="6">
                        <div className="cardContact">
                            <span>
                                <i className="ri-mail-line"> </i> cheffood@gmail.com
                            </span>
                        </div>
                    </Col>
                    <Col lg="3" md="3" sm="6">
                        <div className="cardContact">
                            <span>
                                <i className="ri-phone-line"> </i>+880 123 456 789
                            </span>
                        </div>
                    </Col>
                    <Col lg="3" md="3" sm="6">
                        <div className="cardContact">
                            <span>
                                <i className="ri-global-line"> </i>cheffood.com
                            </span>
                        </div>
                    </Col>
                </Row>

                <Row className="contact__content__bottom">
                    <Col lg="6" md="6" sm="12">
                        <div className="map">
                            <h3>Chef Food on Map</h3>

                            <iframe
                                title="Chef Food on Google Map"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d134750.66019603095!2d-77.56076872650972!3d38.79978193336899!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7c6de5af6e45b%3A0xc2524522d4885d2a!2zT2EteGluaC10xqFuLCBRdeG6rW4gQ29sdW1iaWE!5e0!3m2!1svi!2sus!4v1648360058949!5m2!1svi!2sus"
                                width="100%"
                                height="510"
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>
                    </Col>
                    <Col lg="6" md="6" sm="12">
                        <div className="form">
                            <h3>Send us a message</h3>
                            <p>
                                And we’ll get back to you as soon as possible. Looking forward to
                                hearing from you.
                            </p>
                            <div className="contact-form">
                                <input type="text" placeholder="Name" />
                                <input type="email" placeholder="Email" />
                                <input type="text" placeholder="Phone number" />
                                <textarea
                                    name=""
                                    id=""
                                    cols="30"
                                    rows="4"
                                    placeholder="Your message"
                                ></textarea>
                                <button className="btn rev">SEND</button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Contact;
